/**
 * Jury staking: approve (FRDM) → lockStake.
 *
 * Unstaking no longer goes through the wallet: `unlockStake` is admin-only on
 * the router and the backend sends it (`POST /user/jury-stake/unlock`). The
 * UNLOCK step stays registered only so a journal row written before that
 * change still resolves on reload; nothing creates new ones.
 *
 * No outbox effect — the post-confirmation work here is `getAllStakingData` and
 * `getUserDetails`, both pure reads that refresh the screen. Nothing is owed to
 * the backend, so there is nothing a retry could deliver. Journal coverage
 * alone, which restores the pending/success state across a reload.
 */

import { registerFlow } from "../flows";
import { approveSatisfied } from "../verifiers";

export const STAKE_FLOW = "stake";
export const STAKE_STEPS = {
  APPROVE: "approve",
  LOCK: "lockStake",
  UNLOCK: "unlockStake",
};

registerFlow({
  id: STAKE_FLOW,
  steps: {
    [STAKE_STEPS.APPROVE]: { verifyOnChain: approveSatisfied },
    [STAKE_STEPS.LOCK]: {},
    [STAKE_STEPS.UNLOCK]: {},
  },
});
